import { useContext } from 'react';

import { Context } from './LanguageProvider';

export const useLanguage = () => {
  const result = useContext(Context);
  if (typeof result === 'undefined') {
    throw new Error(
      'The useLanguage hook must be used within a LanguageProvider component.',
    );
  }
  return result;
};
